jQuery(function($){
	
	// 테블릿 분기
	var maxPositionSetValue =  ( GsBase.device == 'pc' ) ? false : true;
	var swiperSpeed =  ( GsBase.device == 'pc' ) ? 0 : 500;
	var swiperLoop =  ( GsBase.device == 'pc' ) ? false : true;	

	// 카테고리
	var wine25CateBnr = $('.item-module.bannerTypeC [data-swipe="flex-swiper7"]').gsSwiper({
		activeClass: 'active',
		autoplay:0,
		speed:0,
		slidesPerView:7,
		slidesPerGroup:7,
		rePerView:7,
		slideIS:true,
        calculateHeight: true,
        cssWidthAndHeight: false,
		onInit: function(swiper){
			var index = swiper.activeIndex;
			var indexNo = wine25CateBnr.find('.swiper-slide.on').not('.swiper-slide-duplicate').index() - index;
			
			if(indexNo < 7) {
				swiper.swipeTo(0, 0);
			} else if(indexNo < 14) {
				swiper.swipeTo(7, 0);
			} else if(indexNo < 21) {
				swiper.swipeTo(14, 0);
			} else if(indexNo < 28) {
				swiper.swipeTo(21, 0);
			} else if(indexNo < 35) {
				swiper.swipeTo(28, 0);
			}
			
			return false;
		}, 
	});
	
	// 카테고리 7개(2페이지) 이하일경우 이전/다음 버튼 비노출
	if($('.item-module.bannerTypeC').find('.swiper-slide').length < 8){
		$('.item-module.bannerTypeC').find('button').hide();
	}
	

	// 메인 빅배너
	$('[data-swipe="fade-swiper"].wine25-fix-big-banner').gsSwiper({
		mode:'fade',
		autoplay: 3000,
		speed: 10,
		intervalTime:true,
        calculateHeight: true,
        cssWidthAndHeight: true,
		onInit: function(current, total, $view ){
			$('[data-swipe="fade-swiper"].wine25-fix-big-banner').find('.swiper-slide').each(function(){
				$(this).css({backgroundColor: $(this).data('color')});
			});

			// 페이지 카운터 (2018-12-06)
			var offer = document.querySelector('.wine25-fix-big-banner span.pagination');
			var currentIdx = current + 1;
				offer.innerHTML = '<strong>' + currentIdx + '</strong>' + ' / ' + total;

			// 배너 1개일때 Next, Prev 버튼 숨기기
			if(total <= 1) {
				$('[data-swipe="fade-swiper"].wine25-fix-big-banner').find('.ctrl-btn.prev, .ctrl-btn.next').css('visibility', 'hidden');
				$('[data-swipe="fade-swiper"].wine25-fix-big-banner').find('.gui-nav.swiper-navi').hide();
			}
		}
	});

	// Type A
	$('[data-swipe=flex-swiper5]').gsSwiper({ 
		autoplay:0, 
		speed:500, 
		slideIS:true, 
		resizeIS:true, 
		cssWidthAndHeight: true,
	});

	//2021-10-06 HANGBOT-20192 띠배너
	$('.bannerTypeA [data-swipe=fade-swiper].mod-stage').gsSwiper({
		mode:'fade',
		autoplay:0,
		speed: 0
		//intervalTime:true
	});

	//GRIT-10405 2단 배너 추가
	$('[data-swipe=swiper3]').gsSwiper({
		autoplay: 0,
		slidesPerView: 2,
		slidesPerGroup: 2,
		cssWidthAndHeight: true, 
	});

	//GRIT-10405 베스트 상품 스와이퍼
	$('[data-swipe=page-swiper]').gsSwiper({
		autoplay:0,
		speed:500,
		slideIS:true,
		resizeIS:true,
	});


	// Banner Type Five
	// 브랜드 5단 배너
	$('[data-swipe=ban-list5]').gsSwiper({ 
		// loop:false, 
		autoplay: 0,
		maxPositionSet: false,  
		speed: 500, 
		slidesPerView: 5, 
		slidesPerGroup: 5, 
		rePerView:5,  
		slideIS:true, 
		resizeIS:true, 
		cssWidthAndHeight: true,
	});

});